module.exports = __webpack_public_path__ + "static/media/drought-before.dadda11c.png";